// source: v2/billing_api.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js');
goog.object.extend(proto, google_protobuf_wrappers_pb);
var v2_types_pagination_pb = require('../v2/types/pagination_pb.js');
goog.object.extend(proto, v2_types_pagination_pb);
var v2_types_billing_pb = require('../v2/types/billing_pb.js');
goog.object.extend(proto, v2_types_billing_pb);
goog.exportSymbol('proto.loopup.ctgateway.v2.AddAdvancedPaymentRequest', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.AddAdvancedPaymentResponse', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.AddCreditRequest', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.AddCreditResponse', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.AddGroupCommitmentRequest', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.AddGroupCommitmentResponse', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.AddOneOffChargeRequest', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.AddOneOffChargeResponse', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.GetActiveBillingPeriodsRequest', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.GetActiveBillingPeriodsResponse', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.GetAdvancedPaymentsRequest', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.GetAdvancedPaymentsResponse', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.GetBillingHierarchyRequest', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.GetBillingHierarchyResponse', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.GetChargeGroupsRequest', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.GetChargeGroupsResponse', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.GetCommitmentsForGroupRequest', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.GetCommitmentsForGroupResponse', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.GetCreditsRequest', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.GetCreditsResponse', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.GetOneOffChargesRequest', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.GetOneOffChargesResponse', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.GetProductsRequest', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.GetProductsResponse', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest.RegionCase', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.MakeGroupABillingEntityResponse', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.UpdateBillingEntityRequest', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.UpdateBillingEntityRequest.RegionCase', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.UpdateBillingEntityResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v2.GetBillingHierarchyRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v2.GetBillingHierarchyRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v2.GetBillingHierarchyRequest.displayName = 'proto.loopup.ctgateway.v2.GetBillingHierarchyRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v2.GetBillingHierarchyResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.loopup.ctgateway.v2.GetBillingHierarchyResponse.repeatedFields_, null);
};
goog.inherits(proto.loopup.ctgateway.v2.GetBillingHierarchyResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v2.GetBillingHierarchyResponse.displayName = 'proto.loopup.ctgateway.v2.GetBillingHierarchyResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v2.GetOneOffChargesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v2.GetOneOffChargesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v2.GetOneOffChargesRequest.displayName = 'proto.loopup.ctgateway.v2.GetOneOffChargesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v2.GetOneOffChargesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.loopup.ctgateway.v2.GetOneOffChargesResponse.repeatedFields_, null);
};
goog.inherits(proto.loopup.ctgateway.v2.GetOneOffChargesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v2.GetOneOffChargesResponse.displayName = 'proto.loopup.ctgateway.v2.GetOneOffChargesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v2.GetCreditsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v2.GetCreditsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v2.GetCreditsRequest.displayName = 'proto.loopup.ctgateway.v2.GetCreditsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v2.GetCreditsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.loopup.ctgateway.v2.GetCreditsResponse.repeatedFields_, null);
};
goog.inherits(proto.loopup.ctgateway.v2.GetCreditsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v2.GetCreditsResponse.displayName = 'proto.loopup.ctgateway.v2.GetCreditsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v2.GetAdvancedPaymentsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v2.GetAdvancedPaymentsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v2.GetAdvancedPaymentsRequest.displayName = 'proto.loopup.ctgateway.v2.GetAdvancedPaymentsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v2.GetAdvancedPaymentsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.loopup.ctgateway.v2.GetAdvancedPaymentsResponse.repeatedFields_, null);
};
goog.inherits(proto.loopup.ctgateway.v2.GetAdvancedPaymentsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v2.GetAdvancedPaymentsResponse.displayName = 'proto.loopup.ctgateway.v2.GetAdvancedPaymentsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v2.GetActiveBillingPeriodsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v2.GetActiveBillingPeriodsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v2.GetActiveBillingPeriodsRequest.displayName = 'proto.loopup.ctgateway.v2.GetActiveBillingPeriodsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v2.GetActiveBillingPeriodsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.loopup.ctgateway.v2.GetActiveBillingPeriodsResponse.repeatedFields_, null);
};
goog.inherits(proto.loopup.ctgateway.v2.GetActiveBillingPeriodsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v2.GetActiveBillingPeriodsResponse.displayName = 'proto.loopup.ctgateway.v2.GetActiveBillingPeriodsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v2.AddAdvancedPaymentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v2.AddAdvancedPaymentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v2.AddAdvancedPaymentRequest.displayName = 'proto.loopup.ctgateway.v2.AddAdvancedPaymentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v2.AddAdvancedPaymentResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v2.AddAdvancedPaymentResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v2.AddAdvancedPaymentResponse.displayName = 'proto.loopup.ctgateway.v2.AddAdvancedPaymentResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v2.AddOneOffChargeRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v2.AddOneOffChargeRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v2.AddOneOffChargeRequest.displayName = 'proto.loopup.ctgateway.v2.AddOneOffChargeRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v2.AddOneOffChargeResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v2.AddOneOffChargeResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v2.AddOneOffChargeResponse.displayName = 'proto.loopup.ctgateway.v2.AddOneOffChargeResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v2.AddCreditRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v2.AddCreditRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v2.AddCreditRequest.displayName = 'proto.loopup.ctgateway.v2.AddCreditRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v2.AddCreditResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v2.AddCreditResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v2.AddCreditResponse.displayName = 'proto.loopup.ctgateway.v2.AddCreditResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v2.AddGroupCommitmentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v2.AddGroupCommitmentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v2.AddGroupCommitmentRequest.displayName = 'proto.loopup.ctgateway.v2.AddGroupCommitmentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v2.AddGroupCommitmentResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v2.AddGroupCommitmentResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v2.AddGroupCommitmentResponse.displayName = 'proto.loopup.ctgateway.v2.AddGroupCommitmentResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v2.GetProductsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v2.GetProductsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v2.GetProductsRequest.displayName = 'proto.loopup.ctgateway.v2.GetProductsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v2.GetProductsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.loopup.ctgateway.v2.GetProductsResponse.repeatedFields_, null);
};
goog.inherits(proto.loopup.ctgateway.v2.GetProductsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v2.GetProductsResponse.displayName = 'proto.loopup.ctgateway.v2.GetProductsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v2.GetChargeGroupsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v2.GetChargeGroupsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v2.GetChargeGroupsRequest.displayName = 'proto.loopup.ctgateway.v2.GetChargeGroupsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v2.GetChargeGroupsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.loopup.ctgateway.v2.GetChargeGroupsResponse.repeatedFields_, null);
};
goog.inherits(proto.loopup.ctgateway.v2.GetChargeGroupsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v2.GetChargeGroupsResponse.displayName = 'proto.loopup.ctgateway.v2.GetChargeGroupsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest.oneofGroups_);
};
goog.inherits(proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest.displayName = 'proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v2.MakeGroupABillingEntityResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v2.MakeGroupABillingEntityResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v2.MakeGroupABillingEntityResponse.displayName = 'proto.loopup.ctgateway.v2.MakeGroupABillingEntityResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v2.GetCommitmentsForGroupRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v2.GetCommitmentsForGroupRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v2.GetCommitmentsForGroupRequest.displayName = 'proto.loopup.ctgateway.v2.GetCommitmentsForGroupRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v2.GetCommitmentsForGroupResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.loopup.ctgateway.v2.GetCommitmentsForGroupResponse.repeatedFields_, null);
};
goog.inherits(proto.loopup.ctgateway.v2.GetCommitmentsForGroupResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v2.GetCommitmentsForGroupResponse.displayName = 'proto.loopup.ctgateway.v2.GetCommitmentsForGroupResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v2.UpdateBillingEntityRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.loopup.ctgateway.v2.UpdateBillingEntityRequest.oneofGroups_);
};
goog.inherits(proto.loopup.ctgateway.v2.UpdateBillingEntityRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v2.UpdateBillingEntityRequest.displayName = 'proto.loopup.ctgateway.v2.UpdateBillingEntityRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v2.UpdateBillingEntityResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v2.UpdateBillingEntityResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v2.UpdateBillingEntityResponse.displayName = 'proto.loopup.ctgateway.v2.UpdateBillingEntityResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v2.GetBillingHierarchyRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v2.GetBillingHierarchyRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v2.GetBillingHierarchyRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.GetBillingHierarchyRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    customerId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v2.GetBillingHierarchyRequest}
 */
proto.loopup.ctgateway.v2.GetBillingHierarchyRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v2.GetBillingHierarchyRequest;
  return proto.loopup.ctgateway.v2.GetBillingHierarchyRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v2.GetBillingHierarchyRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v2.GetBillingHierarchyRequest}
 */
proto.loopup.ctgateway.v2.GetBillingHierarchyRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCustomerId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v2.GetBillingHierarchyRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v2.GetBillingHierarchyRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v2.GetBillingHierarchyRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.GetBillingHierarchyRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCustomerId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string customer_id = 1;
 * @return {string}
 */
proto.loopup.ctgateway.v2.GetBillingHierarchyRequest.prototype.getCustomerId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v2.GetBillingHierarchyRequest} returns this
 */
proto.loopup.ctgateway.v2.GetBillingHierarchyRequest.prototype.setCustomerId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.loopup.ctgateway.v2.GetBillingHierarchyResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v2.GetBillingHierarchyResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v2.GetBillingHierarchyResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v2.GetBillingHierarchyResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.GetBillingHierarchyResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    hierarchyGroupsList: jspb.Message.toObjectList(msg.getHierarchyGroupsList(),
    v2_types_billing_pb.HierarchyGroup.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v2.GetBillingHierarchyResponse}
 */
proto.loopup.ctgateway.v2.GetBillingHierarchyResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v2.GetBillingHierarchyResponse;
  return proto.loopup.ctgateway.v2.GetBillingHierarchyResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v2.GetBillingHierarchyResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v2.GetBillingHierarchyResponse}
 */
proto.loopup.ctgateway.v2.GetBillingHierarchyResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new v2_types_billing_pb.HierarchyGroup;
      reader.readMessage(value,v2_types_billing_pb.HierarchyGroup.deserializeBinaryFromReader);
      msg.addHierarchyGroups(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v2.GetBillingHierarchyResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v2.GetBillingHierarchyResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v2.GetBillingHierarchyResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.GetBillingHierarchyResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getHierarchyGroupsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      v2_types_billing_pb.HierarchyGroup.serializeBinaryToWriter
    );
  }
};


/**
 * repeated HierarchyGroup hierarchy_groups = 1;
 * @return {!Array<!proto.loopup.ctgateway.v2.HierarchyGroup>}
 */
proto.loopup.ctgateway.v2.GetBillingHierarchyResponse.prototype.getHierarchyGroupsList = function() {
  return /** @type{!Array<!proto.loopup.ctgateway.v2.HierarchyGroup>} */ (
    jspb.Message.getRepeatedWrapperField(this, v2_types_billing_pb.HierarchyGroup, 1));
};


/**
 * @param {!Array<!proto.loopup.ctgateway.v2.HierarchyGroup>} value
 * @return {!proto.loopup.ctgateway.v2.GetBillingHierarchyResponse} returns this
*/
proto.loopup.ctgateway.v2.GetBillingHierarchyResponse.prototype.setHierarchyGroupsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.loopup.ctgateway.v2.HierarchyGroup=} opt_value
 * @param {number=} opt_index
 * @return {!proto.loopup.ctgateway.v2.HierarchyGroup}
 */
proto.loopup.ctgateway.v2.GetBillingHierarchyResponse.prototype.addHierarchyGroups = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.loopup.ctgateway.v2.HierarchyGroup, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.loopup.ctgateway.v2.GetBillingHierarchyResponse} returns this
 */
proto.loopup.ctgateway.v2.GetBillingHierarchyResponse.prototype.clearHierarchyGroupsList = function() {
  return this.setHierarchyGroupsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v2.GetOneOffChargesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v2.GetOneOffChargesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v2.GetOneOffChargesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.GetOneOffChargesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    customerId: (f = msg.getCustomerId()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    pageNumber: jspb.Message.getFieldWithDefault(msg, 2, 0),
    pageSize: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v2.GetOneOffChargesRequest}
 */
proto.loopup.ctgateway.v2.GetOneOffChargesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v2.GetOneOffChargesRequest;
  return proto.loopup.ctgateway.v2.GetOneOffChargesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v2.GetOneOffChargesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v2.GetOneOffChargesRequest}
 */
proto.loopup.ctgateway.v2.GetOneOffChargesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setCustomerId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageNumber(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageSize(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v2.GetOneOffChargesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v2.GetOneOffChargesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v2.GetOneOffChargesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.GetOneOffChargesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCustomerId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getPageNumber();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional google.protobuf.StringValue customer_id = 1;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.GetOneOffChargesRequest.prototype.getCustomerId = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 1));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.GetOneOffChargesRequest} returns this
*/
proto.loopup.ctgateway.v2.GetOneOffChargesRequest.prototype.setCustomerId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.GetOneOffChargesRequest} returns this
 */
proto.loopup.ctgateway.v2.GetOneOffChargesRequest.prototype.clearCustomerId = function() {
  return this.setCustomerId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.GetOneOffChargesRequest.prototype.hasCustomerId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int32 page_number = 2;
 * @return {number}
 */
proto.loopup.ctgateway.v2.GetOneOffChargesRequest.prototype.getPageNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.loopup.ctgateway.v2.GetOneOffChargesRequest} returns this
 */
proto.loopup.ctgateway.v2.GetOneOffChargesRequest.prototype.setPageNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 page_size = 3;
 * @return {number}
 */
proto.loopup.ctgateway.v2.GetOneOffChargesRequest.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.loopup.ctgateway.v2.GetOneOffChargesRequest} returns this
 */
proto.loopup.ctgateway.v2.GetOneOffChargesRequest.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.loopup.ctgateway.v2.GetOneOffChargesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v2.GetOneOffChargesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v2.GetOneOffChargesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v2.GetOneOffChargesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.GetOneOffChargesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    chargesList: jspb.Message.toObjectList(msg.getChargesList(),
    v2_types_billing_pb.OneOffCharge.toObject, includeInstance),
    paginationInfo: (f = msg.getPaginationInfo()) && v2_types_pagination_pb.PaginationInfo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v2.GetOneOffChargesResponse}
 */
proto.loopup.ctgateway.v2.GetOneOffChargesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v2.GetOneOffChargesResponse;
  return proto.loopup.ctgateway.v2.GetOneOffChargesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v2.GetOneOffChargesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v2.GetOneOffChargesResponse}
 */
proto.loopup.ctgateway.v2.GetOneOffChargesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new v2_types_billing_pb.OneOffCharge;
      reader.readMessage(value,v2_types_billing_pb.OneOffCharge.deserializeBinaryFromReader);
      msg.addCharges(value);
      break;
    case 2:
      var value = new v2_types_pagination_pb.PaginationInfo;
      reader.readMessage(value,v2_types_pagination_pb.PaginationInfo.deserializeBinaryFromReader);
      msg.setPaginationInfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v2.GetOneOffChargesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v2.GetOneOffChargesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v2.GetOneOffChargesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.GetOneOffChargesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getChargesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      v2_types_billing_pb.OneOffCharge.serializeBinaryToWriter
    );
  }
  f = message.getPaginationInfo();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      v2_types_pagination_pb.PaginationInfo.serializeBinaryToWriter
    );
  }
};


/**
 * repeated OneOffCharge charges = 1;
 * @return {!Array<!proto.loopup.ctgateway.v2.OneOffCharge>}
 */
proto.loopup.ctgateway.v2.GetOneOffChargesResponse.prototype.getChargesList = function() {
  return /** @type{!Array<!proto.loopup.ctgateway.v2.OneOffCharge>} */ (
    jspb.Message.getRepeatedWrapperField(this, v2_types_billing_pb.OneOffCharge, 1));
};


/**
 * @param {!Array<!proto.loopup.ctgateway.v2.OneOffCharge>} value
 * @return {!proto.loopup.ctgateway.v2.GetOneOffChargesResponse} returns this
*/
proto.loopup.ctgateway.v2.GetOneOffChargesResponse.prototype.setChargesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.loopup.ctgateway.v2.OneOffCharge=} opt_value
 * @param {number=} opt_index
 * @return {!proto.loopup.ctgateway.v2.OneOffCharge}
 */
proto.loopup.ctgateway.v2.GetOneOffChargesResponse.prototype.addCharges = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.loopup.ctgateway.v2.OneOffCharge, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.loopup.ctgateway.v2.GetOneOffChargesResponse} returns this
 */
proto.loopup.ctgateway.v2.GetOneOffChargesResponse.prototype.clearChargesList = function() {
  return this.setChargesList([]);
};


/**
 * optional PaginationInfo pagination_info = 2;
 * @return {?proto.loopup.ctgateway.v2.PaginationInfo}
 */
proto.loopup.ctgateway.v2.GetOneOffChargesResponse.prototype.getPaginationInfo = function() {
  return /** @type{?proto.loopup.ctgateway.v2.PaginationInfo} */ (
    jspb.Message.getWrapperField(this, v2_types_pagination_pb.PaginationInfo, 2));
};


/**
 * @param {?proto.loopup.ctgateway.v2.PaginationInfo|undefined} value
 * @return {!proto.loopup.ctgateway.v2.GetOneOffChargesResponse} returns this
*/
proto.loopup.ctgateway.v2.GetOneOffChargesResponse.prototype.setPaginationInfo = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.GetOneOffChargesResponse} returns this
 */
proto.loopup.ctgateway.v2.GetOneOffChargesResponse.prototype.clearPaginationInfo = function() {
  return this.setPaginationInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.GetOneOffChargesResponse.prototype.hasPaginationInfo = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v2.GetCreditsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v2.GetCreditsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v2.GetCreditsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.GetCreditsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    customerId: (f = msg.getCustomerId()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    pageNumber: jspb.Message.getFieldWithDefault(msg, 2, 0),
    pageSize: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v2.GetCreditsRequest}
 */
proto.loopup.ctgateway.v2.GetCreditsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v2.GetCreditsRequest;
  return proto.loopup.ctgateway.v2.GetCreditsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v2.GetCreditsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v2.GetCreditsRequest}
 */
proto.loopup.ctgateway.v2.GetCreditsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setCustomerId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageNumber(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageSize(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v2.GetCreditsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v2.GetCreditsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v2.GetCreditsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.GetCreditsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCustomerId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getPageNumber();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional google.protobuf.StringValue customer_id = 1;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.GetCreditsRequest.prototype.getCustomerId = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 1));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.GetCreditsRequest} returns this
*/
proto.loopup.ctgateway.v2.GetCreditsRequest.prototype.setCustomerId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.GetCreditsRequest} returns this
 */
proto.loopup.ctgateway.v2.GetCreditsRequest.prototype.clearCustomerId = function() {
  return this.setCustomerId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.GetCreditsRequest.prototype.hasCustomerId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int32 page_number = 2;
 * @return {number}
 */
proto.loopup.ctgateway.v2.GetCreditsRequest.prototype.getPageNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.loopup.ctgateway.v2.GetCreditsRequest} returns this
 */
proto.loopup.ctgateway.v2.GetCreditsRequest.prototype.setPageNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 page_size = 3;
 * @return {number}
 */
proto.loopup.ctgateway.v2.GetCreditsRequest.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.loopup.ctgateway.v2.GetCreditsRequest} returns this
 */
proto.loopup.ctgateway.v2.GetCreditsRequest.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.loopup.ctgateway.v2.GetCreditsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v2.GetCreditsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v2.GetCreditsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v2.GetCreditsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.GetCreditsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    creditsList: jspb.Message.toObjectList(msg.getCreditsList(),
    v2_types_billing_pb.Credit.toObject, includeInstance),
    paginationInfo: (f = msg.getPaginationInfo()) && v2_types_pagination_pb.PaginationInfo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v2.GetCreditsResponse}
 */
proto.loopup.ctgateway.v2.GetCreditsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v2.GetCreditsResponse;
  return proto.loopup.ctgateway.v2.GetCreditsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v2.GetCreditsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v2.GetCreditsResponse}
 */
proto.loopup.ctgateway.v2.GetCreditsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new v2_types_billing_pb.Credit;
      reader.readMessage(value,v2_types_billing_pb.Credit.deserializeBinaryFromReader);
      msg.addCredits(value);
      break;
    case 2:
      var value = new v2_types_pagination_pb.PaginationInfo;
      reader.readMessage(value,v2_types_pagination_pb.PaginationInfo.deserializeBinaryFromReader);
      msg.setPaginationInfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v2.GetCreditsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v2.GetCreditsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v2.GetCreditsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.GetCreditsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCreditsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      v2_types_billing_pb.Credit.serializeBinaryToWriter
    );
  }
  f = message.getPaginationInfo();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      v2_types_pagination_pb.PaginationInfo.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Credit credits = 1;
 * @return {!Array<!proto.loopup.ctgateway.v2.Credit>}
 */
proto.loopup.ctgateway.v2.GetCreditsResponse.prototype.getCreditsList = function() {
  return /** @type{!Array<!proto.loopup.ctgateway.v2.Credit>} */ (
    jspb.Message.getRepeatedWrapperField(this, v2_types_billing_pb.Credit, 1));
};


/**
 * @param {!Array<!proto.loopup.ctgateway.v2.Credit>} value
 * @return {!proto.loopup.ctgateway.v2.GetCreditsResponse} returns this
*/
proto.loopup.ctgateway.v2.GetCreditsResponse.prototype.setCreditsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.loopup.ctgateway.v2.Credit=} opt_value
 * @param {number=} opt_index
 * @return {!proto.loopup.ctgateway.v2.Credit}
 */
proto.loopup.ctgateway.v2.GetCreditsResponse.prototype.addCredits = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.loopup.ctgateway.v2.Credit, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.loopup.ctgateway.v2.GetCreditsResponse} returns this
 */
proto.loopup.ctgateway.v2.GetCreditsResponse.prototype.clearCreditsList = function() {
  return this.setCreditsList([]);
};


/**
 * optional PaginationInfo pagination_info = 2;
 * @return {?proto.loopup.ctgateway.v2.PaginationInfo}
 */
proto.loopup.ctgateway.v2.GetCreditsResponse.prototype.getPaginationInfo = function() {
  return /** @type{?proto.loopup.ctgateway.v2.PaginationInfo} */ (
    jspb.Message.getWrapperField(this, v2_types_pagination_pb.PaginationInfo, 2));
};


/**
 * @param {?proto.loopup.ctgateway.v2.PaginationInfo|undefined} value
 * @return {!proto.loopup.ctgateway.v2.GetCreditsResponse} returns this
*/
proto.loopup.ctgateway.v2.GetCreditsResponse.prototype.setPaginationInfo = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.GetCreditsResponse} returns this
 */
proto.loopup.ctgateway.v2.GetCreditsResponse.prototype.clearPaginationInfo = function() {
  return this.setPaginationInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.GetCreditsResponse.prototype.hasPaginationInfo = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v2.GetAdvancedPaymentsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v2.GetAdvancedPaymentsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v2.GetAdvancedPaymentsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.GetAdvancedPaymentsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    customerId: (f = msg.getCustomerId()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    pageNumber: jspb.Message.getFieldWithDefault(msg, 2, 0),
    pageSize: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v2.GetAdvancedPaymentsRequest}
 */
proto.loopup.ctgateway.v2.GetAdvancedPaymentsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v2.GetAdvancedPaymentsRequest;
  return proto.loopup.ctgateway.v2.GetAdvancedPaymentsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v2.GetAdvancedPaymentsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v2.GetAdvancedPaymentsRequest}
 */
proto.loopup.ctgateway.v2.GetAdvancedPaymentsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setCustomerId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageNumber(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageSize(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v2.GetAdvancedPaymentsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v2.GetAdvancedPaymentsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v2.GetAdvancedPaymentsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.GetAdvancedPaymentsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCustomerId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getPageNumber();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional google.protobuf.StringValue customer_id = 1;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.GetAdvancedPaymentsRequest.prototype.getCustomerId = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 1));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.GetAdvancedPaymentsRequest} returns this
*/
proto.loopup.ctgateway.v2.GetAdvancedPaymentsRequest.prototype.setCustomerId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.GetAdvancedPaymentsRequest} returns this
 */
proto.loopup.ctgateway.v2.GetAdvancedPaymentsRequest.prototype.clearCustomerId = function() {
  return this.setCustomerId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.GetAdvancedPaymentsRequest.prototype.hasCustomerId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int32 page_number = 2;
 * @return {number}
 */
proto.loopup.ctgateway.v2.GetAdvancedPaymentsRequest.prototype.getPageNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.loopup.ctgateway.v2.GetAdvancedPaymentsRequest} returns this
 */
proto.loopup.ctgateway.v2.GetAdvancedPaymentsRequest.prototype.setPageNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 page_size = 3;
 * @return {number}
 */
proto.loopup.ctgateway.v2.GetAdvancedPaymentsRequest.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.loopup.ctgateway.v2.GetAdvancedPaymentsRequest} returns this
 */
proto.loopup.ctgateway.v2.GetAdvancedPaymentsRequest.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.loopup.ctgateway.v2.GetAdvancedPaymentsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v2.GetAdvancedPaymentsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v2.GetAdvancedPaymentsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v2.GetAdvancedPaymentsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.GetAdvancedPaymentsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    advancedPaymentsList: jspb.Message.toObjectList(msg.getAdvancedPaymentsList(),
    v2_types_billing_pb.AdvancedPayment.toObject, includeInstance),
    paginationInfo: (f = msg.getPaginationInfo()) && v2_types_pagination_pb.PaginationInfo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v2.GetAdvancedPaymentsResponse}
 */
proto.loopup.ctgateway.v2.GetAdvancedPaymentsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v2.GetAdvancedPaymentsResponse;
  return proto.loopup.ctgateway.v2.GetAdvancedPaymentsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v2.GetAdvancedPaymentsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v2.GetAdvancedPaymentsResponse}
 */
proto.loopup.ctgateway.v2.GetAdvancedPaymentsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new v2_types_billing_pb.AdvancedPayment;
      reader.readMessage(value,v2_types_billing_pb.AdvancedPayment.deserializeBinaryFromReader);
      msg.addAdvancedPayments(value);
      break;
    case 2:
      var value = new v2_types_pagination_pb.PaginationInfo;
      reader.readMessage(value,v2_types_pagination_pb.PaginationInfo.deserializeBinaryFromReader);
      msg.setPaginationInfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v2.GetAdvancedPaymentsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v2.GetAdvancedPaymentsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v2.GetAdvancedPaymentsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.GetAdvancedPaymentsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAdvancedPaymentsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      v2_types_billing_pb.AdvancedPayment.serializeBinaryToWriter
    );
  }
  f = message.getPaginationInfo();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      v2_types_pagination_pb.PaginationInfo.serializeBinaryToWriter
    );
  }
};


/**
 * repeated AdvancedPayment advanced_payments = 1;
 * @return {!Array<!proto.loopup.ctgateway.v2.AdvancedPayment>}
 */
proto.loopup.ctgateway.v2.GetAdvancedPaymentsResponse.prototype.getAdvancedPaymentsList = function() {
  return /** @type{!Array<!proto.loopup.ctgateway.v2.AdvancedPayment>} */ (
    jspb.Message.getRepeatedWrapperField(this, v2_types_billing_pb.AdvancedPayment, 1));
};


/**
 * @param {!Array<!proto.loopup.ctgateway.v2.AdvancedPayment>} value
 * @return {!proto.loopup.ctgateway.v2.GetAdvancedPaymentsResponse} returns this
*/
proto.loopup.ctgateway.v2.GetAdvancedPaymentsResponse.prototype.setAdvancedPaymentsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.loopup.ctgateway.v2.AdvancedPayment=} opt_value
 * @param {number=} opt_index
 * @return {!proto.loopup.ctgateway.v2.AdvancedPayment}
 */
proto.loopup.ctgateway.v2.GetAdvancedPaymentsResponse.prototype.addAdvancedPayments = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.loopup.ctgateway.v2.AdvancedPayment, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.loopup.ctgateway.v2.GetAdvancedPaymentsResponse} returns this
 */
proto.loopup.ctgateway.v2.GetAdvancedPaymentsResponse.prototype.clearAdvancedPaymentsList = function() {
  return this.setAdvancedPaymentsList([]);
};


/**
 * optional PaginationInfo pagination_info = 2;
 * @return {?proto.loopup.ctgateway.v2.PaginationInfo}
 */
proto.loopup.ctgateway.v2.GetAdvancedPaymentsResponse.prototype.getPaginationInfo = function() {
  return /** @type{?proto.loopup.ctgateway.v2.PaginationInfo} */ (
    jspb.Message.getWrapperField(this, v2_types_pagination_pb.PaginationInfo, 2));
};


/**
 * @param {?proto.loopup.ctgateway.v2.PaginationInfo|undefined} value
 * @return {!proto.loopup.ctgateway.v2.GetAdvancedPaymentsResponse} returns this
*/
proto.loopup.ctgateway.v2.GetAdvancedPaymentsResponse.prototype.setPaginationInfo = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.GetAdvancedPaymentsResponse} returns this
 */
proto.loopup.ctgateway.v2.GetAdvancedPaymentsResponse.prototype.clearPaginationInfo = function() {
  return this.setPaginationInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.GetAdvancedPaymentsResponse.prototype.hasPaginationInfo = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v2.GetActiveBillingPeriodsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v2.GetActiveBillingPeriodsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v2.GetActiveBillingPeriodsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.GetActiveBillingPeriodsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    groupId: (f = msg.getGroupId()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v2.GetActiveBillingPeriodsRequest}
 */
proto.loopup.ctgateway.v2.GetActiveBillingPeriodsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v2.GetActiveBillingPeriodsRequest;
  return proto.loopup.ctgateway.v2.GetActiveBillingPeriodsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v2.GetActiveBillingPeriodsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v2.GetActiveBillingPeriodsRequest}
 */
proto.loopup.ctgateway.v2.GetActiveBillingPeriodsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setGroupId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v2.GetActiveBillingPeriodsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v2.GetActiveBillingPeriodsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v2.GetActiveBillingPeriodsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.GetActiveBillingPeriodsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGroupId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.StringValue group_id = 1;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.GetActiveBillingPeriodsRequest.prototype.getGroupId = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 1));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.GetActiveBillingPeriodsRequest} returns this
*/
proto.loopup.ctgateway.v2.GetActiveBillingPeriodsRequest.prototype.setGroupId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.GetActiveBillingPeriodsRequest} returns this
 */
proto.loopup.ctgateway.v2.GetActiveBillingPeriodsRequest.prototype.clearGroupId = function() {
  return this.setGroupId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.GetActiveBillingPeriodsRequest.prototype.hasGroupId = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.loopup.ctgateway.v2.GetActiveBillingPeriodsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v2.GetActiveBillingPeriodsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v2.GetActiveBillingPeriodsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v2.GetActiveBillingPeriodsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.GetActiveBillingPeriodsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    billingPeriodsList: jspb.Message.toObjectList(msg.getBillingPeriodsList(),
    v2_types_billing_pb.BillingPeriod.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v2.GetActiveBillingPeriodsResponse}
 */
proto.loopup.ctgateway.v2.GetActiveBillingPeriodsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v2.GetActiveBillingPeriodsResponse;
  return proto.loopup.ctgateway.v2.GetActiveBillingPeriodsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v2.GetActiveBillingPeriodsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v2.GetActiveBillingPeriodsResponse}
 */
proto.loopup.ctgateway.v2.GetActiveBillingPeriodsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new v2_types_billing_pb.BillingPeriod;
      reader.readMessage(value,v2_types_billing_pb.BillingPeriod.deserializeBinaryFromReader);
      msg.addBillingPeriods(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v2.GetActiveBillingPeriodsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v2.GetActiveBillingPeriodsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v2.GetActiveBillingPeriodsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.GetActiveBillingPeriodsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBillingPeriodsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      v2_types_billing_pb.BillingPeriod.serializeBinaryToWriter
    );
  }
};


/**
 * repeated BillingPeriod billing_periods = 1;
 * @return {!Array<!proto.loopup.ctgateway.v2.BillingPeriod>}
 */
proto.loopup.ctgateway.v2.GetActiveBillingPeriodsResponse.prototype.getBillingPeriodsList = function() {
  return /** @type{!Array<!proto.loopup.ctgateway.v2.BillingPeriod>} */ (
    jspb.Message.getRepeatedWrapperField(this, v2_types_billing_pb.BillingPeriod, 1));
};


/**
 * @param {!Array<!proto.loopup.ctgateway.v2.BillingPeriod>} value
 * @return {!proto.loopup.ctgateway.v2.GetActiveBillingPeriodsResponse} returns this
*/
proto.loopup.ctgateway.v2.GetActiveBillingPeriodsResponse.prototype.setBillingPeriodsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.loopup.ctgateway.v2.BillingPeriod=} opt_value
 * @param {number=} opt_index
 * @return {!proto.loopup.ctgateway.v2.BillingPeriod}
 */
proto.loopup.ctgateway.v2.GetActiveBillingPeriodsResponse.prototype.addBillingPeriods = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.loopup.ctgateway.v2.BillingPeriod, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.loopup.ctgateway.v2.GetActiveBillingPeriodsResponse} returns this
 */
proto.loopup.ctgateway.v2.GetActiveBillingPeriodsResponse.prototype.clearBillingPeriodsList = function() {
  return this.setBillingPeriodsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v2.AddAdvancedPaymentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v2.AddAdvancedPaymentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v2.AddAdvancedPaymentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.AddAdvancedPaymentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    groupId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    advancedPaymentAmount: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
    coverPeriodStartDateTime: (f = msg.getCoverPeriodStartDateTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    numberOfMonthsToCover: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v2.AddAdvancedPaymentRequest}
 */
proto.loopup.ctgateway.v2.AddAdvancedPaymentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v2.AddAdvancedPaymentRequest;
  return proto.loopup.ctgateway.v2.AddAdvancedPaymentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v2.AddAdvancedPaymentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v2.AddAdvancedPaymentRequest}
 */
proto.loopup.ctgateway.v2.AddAdvancedPaymentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setGroupId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAdvancedPaymentAmount(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCoverPeriodStartDateTime(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setNumberOfMonthsToCover(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v2.AddAdvancedPaymentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v2.AddAdvancedPaymentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v2.AddAdvancedPaymentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.AddAdvancedPaymentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGroupId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAdvancedPaymentAmount();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getCoverPeriodStartDateTime();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getNumberOfMonthsToCover();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * optional string group_id = 1;
 * @return {string}
 */
proto.loopup.ctgateway.v2.AddAdvancedPaymentRequest.prototype.getGroupId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v2.AddAdvancedPaymentRequest} returns this
 */
proto.loopup.ctgateway.v2.AddAdvancedPaymentRequest.prototype.setGroupId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional double advanced_payment_amount = 2;
 * @return {number}
 */
proto.loopup.ctgateway.v2.AddAdvancedPaymentRequest.prototype.getAdvancedPaymentAmount = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.loopup.ctgateway.v2.AddAdvancedPaymentRequest} returns this
 */
proto.loopup.ctgateway.v2.AddAdvancedPaymentRequest.prototype.setAdvancedPaymentAmount = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional google.protobuf.Timestamp cover_period_start_date_time = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.loopup.ctgateway.v2.AddAdvancedPaymentRequest.prototype.getCoverPeriodStartDateTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.loopup.ctgateway.v2.AddAdvancedPaymentRequest} returns this
*/
proto.loopup.ctgateway.v2.AddAdvancedPaymentRequest.prototype.setCoverPeriodStartDateTime = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.AddAdvancedPaymentRequest} returns this
 */
proto.loopup.ctgateway.v2.AddAdvancedPaymentRequest.prototype.clearCoverPeriodStartDateTime = function() {
  return this.setCoverPeriodStartDateTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.AddAdvancedPaymentRequest.prototype.hasCoverPeriodStartDateTime = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional int32 number_of_months_to_cover = 4;
 * @return {number}
 */
proto.loopup.ctgateway.v2.AddAdvancedPaymentRequest.prototype.getNumberOfMonthsToCover = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.loopup.ctgateway.v2.AddAdvancedPaymentRequest} returns this
 */
proto.loopup.ctgateway.v2.AddAdvancedPaymentRequest.prototype.setNumberOfMonthsToCover = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v2.AddAdvancedPaymentResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v2.AddAdvancedPaymentResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v2.AddAdvancedPaymentResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.AddAdvancedPaymentResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    advancedPayment: (f = msg.getAdvancedPayment()) && v2_types_billing_pb.AdvancedPayment.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v2.AddAdvancedPaymentResponse}
 */
proto.loopup.ctgateway.v2.AddAdvancedPaymentResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v2.AddAdvancedPaymentResponse;
  return proto.loopup.ctgateway.v2.AddAdvancedPaymentResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v2.AddAdvancedPaymentResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v2.AddAdvancedPaymentResponse}
 */
proto.loopup.ctgateway.v2.AddAdvancedPaymentResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new v2_types_billing_pb.AdvancedPayment;
      reader.readMessage(value,v2_types_billing_pb.AdvancedPayment.deserializeBinaryFromReader);
      msg.setAdvancedPayment(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v2.AddAdvancedPaymentResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v2.AddAdvancedPaymentResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v2.AddAdvancedPaymentResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.AddAdvancedPaymentResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAdvancedPayment();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      v2_types_billing_pb.AdvancedPayment.serializeBinaryToWriter
    );
  }
};


/**
 * optional AdvancedPayment advanced_payment = 1;
 * @return {?proto.loopup.ctgateway.v2.AdvancedPayment}
 */
proto.loopup.ctgateway.v2.AddAdvancedPaymentResponse.prototype.getAdvancedPayment = function() {
  return /** @type{?proto.loopup.ctgateway.v2.AdvancedPayment} */ (
    jspb.Message.getWrapperField(this, v2_types_billing_pb.AdvancedPayment, 1));
};


/**
 * @param {?proto.loopup.ctgateway.v2.AdvancedPayment|undefined} value
 * @return {!proto.loopup.ctgateway.v2.AddAdvancedPaymentResponse} returns this
*/
proto.loopup.ctgateway.v2.AddAdvancedPaymentResponse.prototype.setAdvancedPayment = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.AddAdvancedPaymentResponse} returns this
 */
proto.loopup.ctgateway.v2.AddAdvancedPaymentResponse.prototype.clearAdvancedPayment = function() {
  return this.setAdvancedPayment(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.AddAdvancedPaymentResponse.prototype.hasAdvancedPayment = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v2.AddOneOffChargeRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v2.AddOneOffChargeRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v2.AddOneOffChargeRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.AddOneOffChargeRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    groupId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    quantity: jspb.Message.getFieldWithDefault(msg, 2, 0),
    price: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
    description: jspb.Message.getFieldWithDefault(msg, 4, ""),
    productId: jspb.Message.getFieldWithDefault(msg, 5, ""),
    chargeDateTime: (f = msg.getChargeDateTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v2.AddOneOffChargeRequest}
 */
proto.loopup.ctgateway.v2.AddOneOffChargeRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v2.AddOneOffChargeRequest;
  return proto.loopup.ctgateway.v2.AddOneOffChargeRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v2.AddOneOffChargeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v2.AddOneOffChargeRequest}
 */
proto.loopup.ctgateway.v2.AddOneOffChargeRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setGroupId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setQuantity(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPrice(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductId(value);
      break;
    case 6:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setChargeDateTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v2.AddOneOffChargeRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v2.AddOneOffChargeRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v2.AddOneOffChargeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.AddOneOffChargeRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGroupId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getQuantity();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getPrice();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getProductId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getChargeDateTime();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string group_id = 1;
 * @return {string}
 */
proto.loopup.ctgateway.v2.AddOneOffChargeRequest.prototype.getGroupId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v2.AddOneOffChargeRequest} returns this
 */
proto.loopup.ctgateway.v2.AddOneOffChargeRequest.prototype.setGroupId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 quantity = 2;
 * @return {number}
 */
proto.loopup.ctgateway.v2.AddOneOffChargeRequest.prototype.getQuantity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.loopup.ctgateway.v2.AddOneOffChargeRequest} returns this
 */
proto.loopup.ctgateway.v2.AddOneOffChargeRequest.prototype.setQuantity = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional double price = 3;
 * @return {number}
 */
proto.loopup.ctgateway.v2.AddOneOffChargeRequest.prototype.getPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.loopup.ctgateway.v2.AddOneOffChargeRequest} returns this
 */
proto.loopup.ctgateway.v2.AddOneOffChargeRequest.prototype.setPrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional string description = 4;
 * @return {string}
 */
proto.loopup.ctgateway.v2.AddOneOffChargeRequest.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v2.AddOneOffChargeRequest} returns this
 */
proto.loopup.ctgateway.v2.AddOneOffChargeRequest.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string product_id = 5;
 * @return {string}
 */
proto.loopup.ctgateway.v2.AddOneOffChargeRequest.prototype.getProductId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v2.AddOneOffChargeRequest} returns this
 */
proto.loopup.ctgateway.v2.AddOneOffChargeRequest.prototype.setProductId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional google.protobuf.Timestamp charge_date_time = 6;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.loopup.ctgateway.v2.AddOneOffChargeRequest.prototype.getChargeDateTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 6));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.loopup.ctgateway.v2.AddOneOffChargeRequest} returns this
*/
proto.loopup.ctgateway.v2.AddOneOffChargeRequest.prototype.setChargeDateTime = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.AddOneOffChargeRequest} returns this
 */
proto.loopup.ctgateway.v2.AddOneOffChargeRequest.prototype.clearChargeDateTime = function() {
  return this.setChargeDateTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.AddOneOffChargeRequest.prototype.hasChargeDateTime = function() {
  return jspb.Message.getField(this, 6) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v2.AddOneOffChargeResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v2.AddOneOffChargeResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v2.AddOneOffChargeResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.AddOneOffChargeResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    charge: (f = msg.getCharge()) && v2_types_billing_pb.OneOffCharge.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v2.AddOneOffChargeResponse}
 */
proto.loopup.ctgateway.v2.AddOneOffChargeResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v2.AddOneOffChargeResponse;
  return proto.loopup.ctgateway.v2.AddOneOffChargeResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v2.AddOneOffChargeResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v2.AddOneOffChargeResponse}
 */
proto.loopup.ctgateway.v2.AddOneOffChargeResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new v2_types_billing_pb.OneOffCharge;
      reader.readMessage(value,v2_types_billing_pb.OneOffCharge.deserializeBinaryFromReader);
      msg.setCharge(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v2.AddOneOffChargeResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v2.AddOneOffChargeResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v2.AddOneOffChargeResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.AddOneOffChargeResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCharge();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      v2_types_billing_pb.OneOffCharge.serializeBinaryToWriter
    );
  }
};


/**
 * optional OneOffCharge charge = 1;
 * @return {?proto.loopup.ctgateway.v2.OneOffCharge}
 */
proto.loopup.ctgateway.v2.AddOneOffChargeResponse.prototype.getCharge = function() {
  return /** @type{?proto.loopup.ctgateway.v2.OneOffCharge} */ (
    jspb.Message.getWrapperField(this, v2_types_billing_pb.OneOffCharge, 1));
};


/**
 * @param {?proto.loopup.ctgateway.v2.OneOffCharge|undefined} value
 * @return {!proto.loopup.ctgateway.v2.AddOneOffChargeResponse} returns this
*/
proto.loopup.ctgateway.v2.AddOneOffChargeResponse.prototype.setCharge = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.AddOneOffChargeResponse} returns this
 */
proto.loopup.ctgateway.v2.AddOneOffChargeResponse.prototype.clearCharge = function() {
  return this.setCharge(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.AddOneOffChargeResponse.prototype.hasCharge = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v2.AddCreditRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v2.AddCreditRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v2.AddCreditRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.AddCreditRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    groupId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    price: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
    description: jspb.Message.getFieldWithDefault(msg, 3, ""),
    productId: jspb.Message.getFieldWithDefault(msg, 4, ""),
    creditDateTime: (f = msg.getCreditDateTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v2.AddCreditRequest}
 */
proto.loopup.ctgateway.v2.AddCreditRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v2.AddCreditRequest;
  return proto.loopup.ctgateway.v2.AddCreditRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v2.AddCreditRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v2.AddCreditRequest}
 */
proto.loopup.ctgateway.v2.AddCreditRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setGroupId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPrice(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductId(value);
      break;
    case 5:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreditDateTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v2.AddCreditRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v2.AddCreditRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v2.AddCreditRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.AddCreditRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGroupId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPrice();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getProductId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getCreditDateTime();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string group_id = 1;
 * @return {string}
 */
proto.loopup.ctgateway.v2.AddCreditRequest.prototype.getGroupId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v2.AddCreditRequest} returns this
 */
proto.loopup.ctgateway.v2.AddCreditRequest.prototype.setGroupId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional double price = 2;
 * @return {number}
 */
proto.loopup.ctgateway.v2.AddCreditRequest.prototype.getPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.loopup.ctgateway.v2.AddCreditRequest} returns this
 */
proto.loopup.ctgateway.v2.AddCreditRequest.prototype.setPrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional string description = 3;
 * @return {string}
 */
proto.loopup.ctgateway.v2.AddCreditRequest.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v2.AddCreditRequest} returns this
 */
proto.loopup.ctgateway.v2.AddCreditRequest.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string product_id = 4;
 * @return {string}
 */
proto.loopup.ctgateway.v2.AddCreditRequest.prototype.getProductId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v2.AddCreditRequest} returns this
 */
proto.loopup.ctgateway.v2.AddCreditRequest.prototype.setProductId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional google.protobuf.Timestamp credit_date_time = 5;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.loopup.ctgateway.v2.AddCreditRequest.prototype.getCreditDateTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.loopup.ctgateway.v2.AddCreditRequest} returns this
*/
proto.loopup.ctgateway.v2.AddCreditRequest.prototype.setCreditDateTime = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.AddCreditRequest} returns this
 */
proto.loopup.ctgateway.v2.AddCreditRequest.prototype.clearCreditDateTime = function() {
  return this.setCreditDateTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.AddCreditRequest.prototype.hasCreditDateTime = function() {
  return jspb.Message.getField(this, 5) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v2.AddCreditResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v2.AddCreditResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v2.AddCreditResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.AddCreditResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    credit: (f = msg.getCredit()) && v2_types_billing_pb.Credit.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v2.AddCreditResponse}
 */
proto.loopup.ctgateway.v2.AddCreditResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v2.AddCreditResponse;
  return proto.loopup.ctgateway.v2.AddCreditResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v2.AddCreditResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v2.AddCreditResponse}
 */
proto.loopup.ctgateway.v2.AddCreditResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new v2_types_billing_pb.Credit;
      reader.readMessage(value,v2_types_billing_pb.Credit.deserializeBinaryFromReader);
      msg.setCredit(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v2.AddCreditResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v2.AddCreditResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v2.AddCreditResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.AddCreditResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCredit();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      v2_types_billing_pb.Credit.serializeBinaryToWriter
    );
  }
};


/**
 * optional Credit credit = 1;
 * @return {?proto.loopup.ctgateway.v2.Credit}
 */
proto.loopup.ctgateway.v2.AddCreditResponse.prototype.getCredit = function() {
  return /** @type{?proto.loopup.ctgateway.v2.Credit} */ (
    jspb.Message.getWrapperField(this, v2_types_billing_pb.Credit, 1));
};


/**
 * @param {?proto.loopup.ctgateway.v2.Credit|undefined} value
 * @return {!proto.loopup.ctgateway.v2.AddCreditResponse} returns this
*/
proto.loopup.ctgateway.v2.AddCreditResponse.prototype.setCredit = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.AddCreditResponse} returns this
 */
proto.loopup.ctgateway.v2.AddCreditResponse.prototype.clearCredit = function() {
  return this.setCredit(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.AddCreditResponse.prototype.hasCredit = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v2.AddGroupCommitmentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v2.AddGroupCommitmentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v2.AddGroupCommitmentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.AddGroupCommitmentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    groupId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    contractStartDateTime: (f = msg.getContractStartDateTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    commitmentStartDateTime: (f = msg.getCommitmentStartDateTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    contractEndDateTime: (f = msg.getContractEndDateTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    committedDdis: jspb.Message.getFieldWithDefault(msg, 5, 0),
    pricePerCoreSubscription: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0),
    pricePerPerfectBundle: jspb.Message.getFloatingPointFieldWithDefault(msg, 7, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v2.AddGroupCommitmentRequest}
 */
proto.loopup.ctgateway.v2.AddGroupCommitmentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v2.AddGroupCommitmentRequest;
  return proto.loopup.ctgateway.v2.AddGroupCommitmentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v2.AddGroupCommitmentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v2.AddGroupCommitmentRequest}
 */
proto.loopup.ctgateway.v2.AddGroupCommitmentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setGroupId(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setContractStartDateTime(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCommitmentStartDateTime(value);
      break;
    case 4:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setContractEndDateTime(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCommittedDdis(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPricePerCoreSubscription(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPricePerPerfectBundle(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v2.AddGroupCommitmentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v2.AddGroupCommitmentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v2.AddGroupCommitmentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.AddGroupCommitmentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGroupId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getContractStartDateTime();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getCommitmentStartDateTime();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getContractEndDateTime();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getCommittedDdis();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getPricePerCoreSubscription();
  if (f !== 0.0) {
    writer.writeDouble(
      6,
      f
    );
  }
  f = message.getPricePerPerfectBundle();
  if (f !== 0.0) {
    writer.writeDouble(
      7,
      f
    );
  }
};


/**
 * optional string group_id = 1;
 * @return {string}
 */
proto.loopup.ctgateway.v2.AddGroupCommitmentRequest.prototype.getGroupId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v2.AddGroupCommitmentRequest} returns this
 */
proto.loopup.ctgateway.v2.AddGroupCommitmentRequest.prototype.setGroupId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.Timestamp contract_start_date_time = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.loopup.ctgateway.v2.AddGroupCommitmentRequest.prototype.getContractStartDateTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.loopup.ctgateway.v2.AddGroupCommitmentRequest} returns this
*/
proto.loopup.ctgateway.v2.AddGroupCommitmentRequest.prototype.setContractStartDateTime = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.AddGroupCommitmentRequest} returns this
 */
proto.loopup.ctgateway.v2.AddGroupCommitmentRequest.prototype.clearContractStartDateTime = function() {
  return this.setContractStartDateTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.AddGroupCommitmentRequest.prototype.hasContractStartDateTime = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.Timestamp commitment_start_date_time = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.loopup.ctgateway.v2.AddGroupCommitmentRequest.prototype.getCommitmentStartDateTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.loopup.ctgateway.v2.AddGroupCommitmentRequest} returns this
*/
proto.loopup.ctgateway.v2.AddGroupCommitmentRequest.prototype.setCommitmentStartDateTime = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.AddGroupCommitmentRequest} returns this
 */
proto.loopup.ctgateway.v2.AddGroupCommitmentRequest.prototype.clearCommitmentStartDateTime = function() {
  return this.setCommitmentStartDateTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.AddGroupCommitmentRequest.prototype.hasCommitmentStartDateTime = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.Timestamp contract_end_date_time = 4;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.loopup.ctgateway.v2.AddGroupCommitmentRequest.prototype.getContractEndDateTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 4));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.loopup.ctgateway.v2.AddGroupCommitmentRequest} returns this
*/
proto.loopup.ctgateway.v2.AddGroupCommitmentRequest.prototype.setContractEndDateTime = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.AddGroupCommitmentRequest} returns this
 */
proto.loopup.ctgateway.v2.AddGroupCommitmentRequest.prototype.clearContractEndDateTime = function() {
  return this.setContractEndDateTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.AddGroupCommitmentRequest.prototype.hasContractEndDateTime = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional int32 committed_ddis = 5;
 * @return {number}
 */
proto.loopup.ctgateway.v2.AddGroupCommitmentRequest.prototype.getCommittedDdis = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.loopup.ctgateway.v2.AddGroupCommitmentRequest} returns this
 */
proto.loopup.ctgateway.v2.AddGroupCommitmentRequest.prototype.setCommittedDdis = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional double price_per_core_subscription = 6;
 * @return {number}
 */
proto.loopup.ctgateway.v2.AddGroupCommitmentRequest.prototype.getPricePerCoreSubscription = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.loopup.ctgateway.v2.AddGroupCommitmentRequest} returns this
 */
proto.loopup.ctgateway.v2.AddGroupCommitmentRequest.prototype.setPricePerCoreSubscription = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};


/**
 * optional double price_per_perfect_bundle = 7;
 * @return {number}
 */
proto.loopup.ctgateway.v2.AddGroupCommitmentRequest.prototype.getPricePerPerfectBundle = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 7, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.loopup.ctgateway.v2.AddGroupCommitmentRequest} returns this
 */
proto.loopup.ctgateway.v2.AddGroupCommitmentRequest.prototype.setPricePerPerfectBundle = function(value) {
  return jspb.Message.setProto3FloatField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v2.AddGroupCommitmentResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v2.AddGroupCommitmentResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v2.AddGroupCommitmentResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.AddGroupCommitmentResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    customerId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    groupId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    commitment: (f = msg.getCommitment()) && v2_types_billing_pb.Commitment.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v2.AddGroupCommitmentResponse}
 */
proto.loopup.ctgateway.v2.AddGroupCommitmentResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v2.AddGroupCommitmentResponse;
  return proto.loopup.ctgateway.v2.AddGroupCommitmentResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v2.AddGroupCommitmentResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v2.AddGroupCommitmentResponse}
 */
proto.loopup.ctgateway.v2.AddGroupCommitmentResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCustomerId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setGroupId(value);
      break;
    case 3:
      var value = new v2_types_billing_pb.Commitment;
      reader.readMessage(value,v2_types_billing_pb.Commitment.deserializeBinaryFromReader);
      msg.setCommitment(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v2.AddGroupCommitmentResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v2.AddGroupCommitmentResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v2.AddGroupCommitmentResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.AddGroupCommitmentResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCustomerId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getGroupId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCommitment();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      v2_types_billing_pb.Commitment.serializeBinaryToWriter
    );
  }
};


/**
 * optional string customer_id = 1;
 * @return {string}
 */
proto.loopup.ctgateway.v2.AddGroupCommitmentResponse.prototype.getCustomerId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v2.AddGroupCommitmentResponse} returns this
 */
proto.loopup.ctgateway.v2.AddGroupCommitmentResponse.prototype.setCustomerId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string group_id = 2;
 * @return {string}
 */
proto.loopup.ctgateway.v2.AddGroupCommitmentResponse.prototype.getGroupId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v2.AddGroupCommitmentResponse} returns this
 */
proto.loopup.ctgateway.v2.AddGroupCommitmentResponse.prototype.setGroupId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional Commitment commitment = 3;
 * @return {?proto.loopup.ctgateway.v2.Commitment}
 */
proto.loopup.ctgateway.v2.AddGroupCommitmentResponse.prototype.getCommitment = function() {
  return /** @type{?proto.loopup.ctgateway.v2.Commitment} */ (
    jspb.Message.getWrapperField(this, v2_types_billing_pb.Commitment, 3));
};


/**
 * @param {?proto.loopup.ctgateway.v2.Commitment|undefined} value
 * @return {!proto.loopup.ctgateway.v2.AddGroupCommitmentResponse} returns this
*/
proto.loopup.ctgateway.v2.AddGroupCommitmentResponse.prototype.setCommitment = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.AddGroupCommitmentResponse} returns this
 */
proto.loopup.ctgateway.v2.AddGroupCommitmentResponse.prototype.clearCommitment = function() {
  return this.setCommitment(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.AddGroupCommitmentResponse.prototype.hasCommitment = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v2.GetProductsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v2.GetProductsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v2.GetProductsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.GetProductsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    chargeGroupId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    pageNumber: jspb.Message.getFieldWithDefault(msg, 2, 0),
    pageSize: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v2.GetProductsRequest}
 */
proto.loopup.ctgateway.v2.GetProductsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v2.GetProductsRequest;
  return proto.loopup.ctgateway.v2.GetProductsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v2.GetProductsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v2.GetProductsRequest}
 */
proto.loopup.ctgateway.v2.GetProductsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setChargeGroupId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageNumber(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageSize(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v2.GetProductsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v2.GetProductsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v2.GetProductsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.GetProductsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getChargeGroupId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPageNumber();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional string charge_group_id = 1;
 * @return {string}
 */
proto.loopup.ctgateway.v2.GetProductsRequest.prototype.getChargeGroupId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v2.GetProductsRequest} returns this
 */
proto.loopup.ctgateway.v2.GetProductsRequest.prototype.setChargeGroupId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 page_number = 2;
 * @return {number}
 */
proto.loopup.ctgateway.v2.GetProductsRequest.prototype.getPageNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.loopup.ctgateway.v2.GetProductsRequest} returns this
 */
proto.loopup.ctgateway.v2.GetProductsRequest.prototype.setPageNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 page_size = 3;
 * @return {number}
 */
proto.loopup.ctgateway.v2.GetProductsRequest.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.loopup.ctgateway.v2.GetProductsRequest} returns this
 */
proto.loopup.ctgateway.v2.GetProductsRequest.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.loopup.ctgateway.v2.GetProductsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v2.GetProductsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v2.GetProductsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v2.GetProductsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.GetProductsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    productsList: jspb.Message.toObjectList(msg.getProductsList(),
    v2_types_billing_pb.Product.toObject, includeInstance),
    paginationInfo: (f = msg.getPaginationInfo()) && v2_types_pagination_pb.PaginationInfo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v2.GetProductsResponse}
 */
proto.loopup.ctgateway.v2.GetProductsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v2.GetProductsResponse;
  return proto.loopup.ctgateway.v2.GetProductsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v2.GetProductsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v2.GetProductsResponse}
 */
proto.loopup.ctgateway.v2.GetProductsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new v2_types_billing_pb.Product;
      reader.readMessage(value,v2_types_billing_pb.Product.deserializeBinaryFromReader);
      msg.addProducts(value);
      break;
    case 2:
      var value = new v2_types_pagination_pb.PaginationInfo;
      reader.readMessage(value,v2_types_pagination_pb.PaginationInfo.deserializeBinaryFromReader);
      msg.setPaginationInfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v2.GetProductsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v2.GetProductsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v2.GetProductsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.GetProductsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProductsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      v2_types_billing_pb.Product.serializeBinaryToWriter
    );
  }
  f = message.getPaginationInfo();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      v2_types_pagination_pb.PaginationInfo.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Product products = 1;
 * @return {!Array<!proto.loopup.ctgateway.v2.Product>}
 */
proto.loopup.ctgateway.v2.GetProductsResponse.prototype.getProductsList = function() {
  return /** @type{!Array<!proto.loopup.ctgateway.v2.Product>} */ (
    jspb.Message.getRepeatedWrapperField(this, v2_types_billing_pb.Product, 1));
};


/**
 * @param {!Array<!proto.loopup.ctgateway.v2.Product>} value
 * @return {!proto.loopup.ctgateway.v2.GetProductsResponse} returns this
*/
proto.loopup.ctgateway.v2.GetProductsResponse.prototype.setProductsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.loopup.ctgateway.v2.Product=} opt_value
 * @param {number=} opt_index
 * @return {!proto.loopup.ctgateway.v2.Product}
 */
proto.loopup.ctgateway.v2.GetProductsResponse.prototype.addProducts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.loopup.ctgateway.v2.Product, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.loopup.ctgateway.v2.GetProductsResponse} returns this
 */
proto.loopup.ctgateway.v2.GetProductsResponse.prototype.clearProductsList = function() {
  return this.setProductsList([]);
};


/**
 * optional PaginationInfo pagination_info = 2;
 * @return {?proto.loopup.ctgateway.v2.PaginationInfo}
 */
proto.loopup.ctgateway.v2.GetProductsResponse.prototype.getPaginationInfo = function() {
  return /** @type{?proto.loopup.ctgateway.v2.PaginationInfo} */ (
    jspb.Message.getWrapperField(this, v2_types_pagination_pb.PaginationInfo, 2));
};


/**
 * @param {?proto.loopup.ctgateway.v2.PaginationInfo|undefined} value
 * @return {!proto.loopup.ctgateway.v2.GetProductsResponse} returns this
*/
proto.loopup.ctgateway.v2.GetProductsResponse.prototype.setPaginationInfo = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.GetProductsResponse} returns this
 */
proto.loopup.ctgateway.v2.GetProductsResponse.prototype.clearPaginationInfo = function() {
  return this.setPaginationInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.GetProductsResponse.prototype.hasPaginationInfo = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v2.GetChargeGroupsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v2.GetChargeGroupsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v2.GetChargeGroupsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.GetChargeGroupsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    pageNumber: jspb.Message.getFieldWithDefault(msg, 1, 0),
    pageSize: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v2.GetChargeGroupsRequest}
 */
proto.loopup.ctgateway.v2.GetChargeGroupsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v2.GetChargeGroupsRequest;
  return proto.loopup.ctgateway.v2.GetChargeGroupsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v2.GetChargeGroupsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v2.GetChargeGroupsRequest}
 */
proto.loopup.ctgateway.v2.GetChargeGroupsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageNumber(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageSize(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v2.GetChargeGroupsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v2.GetChargeGroupsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v2.GetChargeGroupsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.GetChargeGroupsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPageNumber();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional int32 page_number = 1;
 * @return {number}
 */
proto.loopup.ctgateway.v2.GetChargeGroupsRequest.prototype.getPageNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.loopup.ctgateway.v2.GetChargeGroupsRequest} returns this
 */
proto.loopup.ctgateway.v2.GetChargeGroupsRequest.prototype.setPageNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 page_size = 2;
 * @return {number}
 */
proto.loopup.ctgateway.v2.GetChargeGroupsRequest.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.loopup.ctgateway.v2.GetChargeGroupsRequest} returns this
 */
proto.loopup.ctgateway.v2.GetChargeGroupsRequest.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.loopup.ctgateway.v2.GetChargeGroupsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v2.GetChargeGroupsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v2.GetChargeGroupsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v2.GetChargeGroupsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.GetChargeGroupsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    chargeGroupsList: jspb.Message.toObjectList(msg.getChargeGroupsList(),
    v2_types_billing_pb.ChargeGroup.toObject, includeInstance),
    paginationInfo: (f = msg.getPaginationInfo()) && v2_types_pagination_pb.PaginationInfo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v2.GetChargeGroupsResponse}
 */
proto.loopup.ctgateway.v2.GetChargeGroupsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v2.GetChargeGroupsResponse;
  return proto.loopup.ctgateway.v2.GetChargeGroupsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v2.GetChargeGroupsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v2.GetChargeGroupsResponse}
 */
proto.loopup.ctgateway.v2.GetChargeGroupsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new v2_types_billing_pb.ChargeGroup;
      reader.readMessage(value,v2_types_billing_pb.ChargeGroup.deserializeBinaryFromReader);
      msg.addChargeGroups(value);
      break;
    case 2:
      var value = new v2_types_pagination_pb.PaginationInfo;
      reader.readMessage(value,v2_types_pagination_pb.PaginationInfo.deserializeBinaryFromReader);
      msg.setPaginationInfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v2.GetChargeGroupsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v2.GetChargeGroupsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v2.GetChargeGroupsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.GetChargeGroupsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getChargeGroupsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      v2_types_billing_pb.ChargeGroup.serializeBinaryToWriter
    );
  }
  f = message.getPaginationInfo();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      v2_types_pagination_pb.PaginationInfo.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ChargeGroup charge_groups = 1;
 * @return {!Array<!proto.loopup.ctgateway.v2.ChargeGroup>}
 */
proto.loopup.ctgateway.v2.GetChargeGroupsResponse.prototype.getChargeGroupsList = function() {
  return /** @type{!Array<!proto.loopup.ctgateway.v2.ChargeGroup>} */ (
    jspb.Message.getRepeatedWrapperField(this, v2_types_billing_pb.ChargeGroup, 1));
};


/**
 * @param {!Array<!proto.loopup.ctgateway.v2.ChargeGroup>} value
 * @return {!proto.loopup.ctgateway.v2.GetChargeGroupsResponse} returns this
*/
proto.loopup.ctgateway.v2.GetChargeGroupsResponse.prototype.setChargeGroupsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.loopup.ctgateway.v2.ChargeGroup=} opt_value
 * @param {number=} opt_index
 * @return {!proto.loopup.ctgateway.v2.ChargeGroup}
 */
proto.loopup.ctgateway.v2.GetChargeGroupsResponse.prototype.addChargeGroups = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.loopup.ctgateway.v2.ChargeGroup, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.loopup.ctgateway.v2.GetChargeGroupsResponse} returns this
 */
proto.loopup.ctgateway.v2.GetChargeGroupsResponse.prototype.clearChargeGroupsList = function() {
  return this.setChargeGroupsList([]);
};


/**
 * optional PaginationInfo pagination_info = 2;
 * @return {?proto.loopup.ctgateway.v2.PaginationInfo}
 */
proto.loopup.ctgateway.v2.GetChargeGroupsResponse.prototype.getPaginationInfo = function() {
  return /** @type{?proto.loopup.ctgateway.v2.PaginationInfo} */ (
    jspb.Message.getWrapperField(this, v2_types_pagination_pb.PaginationInfo, 2));
};


/**
 * @param {?proto.loopup.ctgateway.v2.PaginationInfo|undefined} value
 * @return {!proto.loopup.ctgateway.v2.GetChargeGroupsResponse} returns this
*/
proto.loopup.ctgateway.v2.GetChargeGroupsResponse.prototype.setPaginationInfo = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.GetChargeGroupsResponse} returns this
 */
proto.loopup.ctgateway.v2.GetChargeGroupsResponse.prototype.clearPaginationInfo = function() {
  return this.setPaginationInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.GetChargeGroupsResponse.prototype.hasPaginationInfo = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest.oneofGroups_ = [[10,11,12]];

/**
 * @enum {number}
 */
proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest.RegionCase = {
  REGION_NOT_SET: 0,
  US_STATE: 10,
  CANADIAN_PROVINCE: 11,
  OTHER_REGION: 12
};

/**
 * @return {proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest.RegionCase}
 */
proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest.prototype.getRegionCase = function() {
  return /** @type {proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest.RegionCase} */(jspb.Message.computeOneofCase(this, proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    groupId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    firstname: (f = msg.getFirstname()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    lastname: (f = msg.getLastname()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    emailAddress: (f = msg.getEmailAddress()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    phoneNumber: (f = msg.getPhoneNumber()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    address1: (f = msg.getAddress1()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    address2: (f = msg.getAddress2()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    address3: (f = msg.getAddress3()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    city: (f = msg.getCity()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    usState: jspb.Message.getFieldWithDefault(msg, 10, 0),
    canadianProvince: jspb.Message.getFieldWithDefault(msg, 11, 0),
    otherRegion: (f = msg.getOtherRegion()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    zip: (f = msg.getZip()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    countryCode: (f = msg.getCountryCode()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    company: (f = msg.getCompany()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    currencyCode: (f = msg.getCurrencyCode()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    doNotUploadInvoice: (f = msg.getDoNotUploadInvoice()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest}
 */
proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest;
  return proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest}
 */
proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setGroupId(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setFirstname(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setLastname(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setEmailAddress(value);
      break;
    case 5:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setPhoneNumber(value);
      break;
    case 6:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setAddress1(value);
      break;
    case 7:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setAddress2(value);
      break;
    case 8:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setAddress3(value);
      break;
    case 9:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setCity(value);
      break;
    case 10:
      var value = /** @type {!proto.loopup.ctgateway.v2.UsState} */ (reader.readEnum());
      msg.setUsState(value);
      break;
    case 11:
      var value = /** @type {!proto.loopup.ctgateway.v2.CanadianProvince} */ (reader.readEnum());
      msg.setCanadianProvince(value);
      break;
    case 12:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setOtherRegion(value);
      break;
    case 13:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setZip(value);
      break;
    case 14:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setCountryCode(value);
      break;
    case 15:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setCompany(value);
      break;
    case 16:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setCurrencyCode(value);
      break;
    case 17:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setDoNotUploadInvoice(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGroupId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFirstname();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getLastname();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getEmailAddress();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getPhoneNumber();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getAddress1();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getAddress2();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getAddress3();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getCity();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = /** @type {!proto.loopup.ctgateway.v2.UsState} */ (jspb.Message.getField(message, 10));
  if (f != null) {
    writer.writeEnum(
      10,
      f
    );
  }
  f = /** @type {!proto.loopup.ctgateway.v2.CanadianProvince} */ (jspb.Message.getField(message, 11));
  if (f != null) {
    writer.writeEnum(
      11,
      f
    );
  }
  f = message.getOtherRegion();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getZip();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getCountryCode();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getCompany();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getCurrencyCode();
  if (f != null) {
    writer.writeMessage(
      16,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getDoNotUploadInvoice();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional string group_id = 1;
 * @return {string}
 */
proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest.prototype.getGroupId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest} returns this
 */
proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest.prototype.setGroupId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.StringValue firstname = 2;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest.prototype.getFirstname = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 2));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest} returns this
*/
proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest.prototype.setFirstname = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest} returns this
 */
proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest.prototype.clearFirstname = function() {
  return this.setFirstname(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest.prototype.hasFirstname = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.StringValue lastname = 3;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest.prototype.getLastname = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 3));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest} returns this
*/
proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest.prototype.setLastname = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest} returns this
 */
proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest.prototype.clearLastname = function() {
  return this.setLastname(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest.prototype.hasLastname = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.StringValue email_address = 4;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest.prototype.getEmailAddress = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 4));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest} returns this
*/
proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest.prototype.setEmailAddress = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest} returns this
 */
proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest.prototype.clearEmailAddress = function() {
  return this.setEmailAddress(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest.prototype.hasEmailAddress = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.StringValue phone_number = 5;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest.prototype.getPhoneNumber = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 5));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest} returns this
*/
proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest.prototype.setPhoneNumber = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest} returns this
 */
proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest.prototype.clearPhoneNumber = function() {
  return this.setPhoneNumber(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest.prototype.hasPhoneNumber = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional google.protobuf.StringValue address1 = 6;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest.prototype.getAddress1 = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 6));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest} returns this
*/
proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest.prototype.setAddress1 = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest} returns this
 */
proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest.prototype.clearAddress1 = function() {
  return this.setAddress1(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest.prototype.hasAddress1 = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional google.protobuf.StringValue address2 = 7;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest.prototype.getAddress2 = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 7));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest} returns this
*/
proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest.prototype.setAddress2 = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest} returns this
 */
proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest.prototype.clearAddress2 = function() {
  return this.setAddress2(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest.prototype.hasAddress2 = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional google.protobuf.StringValue address3 = 8;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest.prototype.getAddress3 = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 8));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest} returns this
*/
proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest.prototype.setAddress3 = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest} returns this
 */
proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest.prototype.clearAddress3 = function() {
  return this.setAddress3(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest.prototype.hasAddress3 = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional google.protobuf.StringValue city = 9;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest.prototype.getCity = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 9));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest} returns this
*/
proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest.prototype.setCity = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest} returns this
 */
proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest.prototype.clearCity = function() {
  return this.setCity(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest.prototype.hasCity = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional UsState us_state = 10;
 * @return {!proto.loopup.ctgateway.v2.UsState}
 */
proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest.prototype.getUsState = function() {
  return /** @type {!proto.loopup.ctgateway.v2.UsState} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {!proto.loopup.ctgateway.v2.UsState} value
 * @return {!proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest} returns this
 */
proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest.prototype.setUsState = function(value) {
  return jspb.Message.setOneofField(this, 10, proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest} returns this
 */
proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest.prototype.clearUsState = function() {
  return jspb.Message.setOneofField(this, 10, proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest.prototype.hasUsState = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional CanadianProvince canadian_province = 11;
 * @return {!proto.loopup.ctgateway.v2.CanadianProvince}
 */
proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest.prototype.getCanadianProvince = function() {
  return /** @type {!proto.loopup.ctgateway.v2.CanadianProvince} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {!proto.loopup.ctgateway.v2.CanadianProvince} value
 * @return {!proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest} returns this
 */
proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest.prototype.setCanadianProvince = function(value) {
  return jspb.Message.setOneofField(this, 11, proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest} returns this
 */
proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest.prototype.clearCanadianProvince = function() {
  return jspb.Message.setOneofField(this, 11, proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest.prototype.hasCanadianProvince = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional google.protobuf.StringValue other_region = 12;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest.prototype.getOtherRegion = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 12));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest} returns this
*/
proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest.prototype.setOtherRegion = function(value) {
  return jspb.Message.setOneofWrapperField(this, 12, proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest} returns this
 */
proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest.prototype.clearOtherRegion = function() {
  return this.setOtherRegion(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest.prototype.hasOtherRegion = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional google.protobuf.StringValue zip = 13;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest.prototype.getZip = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 13));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest} returns this
*/
proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest.prototype.setZip = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest} returns this
 */
proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest.prototype.clearZip = function() {
  return this.setZip(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest.prototype.hasZip = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional google.protobuf.StringValue country_code = 14;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest.prototype.getCountryCode = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 14));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest} returns this
*/
proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest.prototype.setCountryCode = function(value) {
  return jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest} returns this
 */
proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest.prototype.clearCountryCode = function() {
  return this.setCountryCode(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest.prototype.hasCountryCode = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional google.protobuf.StringValue company = 15;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest.prototype.getCompany = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 15));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest} returns this
*/
proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest.prototype.setCompany = function(value) {
  return jspb.Message.setWrapperField(this, 15, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest} returns this
 */
proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest.prototype.clearCompany = function() {
  return this.setCompany(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest.prototype.hasCompany = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional google.protobuf.StringValue currency_code = 16;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest.prototype.getCurrencyCode = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 16));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest} returns this
*/
proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest.prototype.setCurrencyCode = function(value) {
  return jspb.Message.setWrapperField(this, 16, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest} returns this
 */
proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest.prototype.clearCurrencyCode = function() {
  return this.setCurrencyCode(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest.prototype.hasCurrencyCode = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * optional google.protobuf.BoolValue do_not_upload_invoice = 17;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest.prototype.getDoNotUploadInvoice = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 17));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest} returns this
*/
proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest.prototype.setDoNotUploadInvoice = function(value) {
  return jspb.Message.setWrapperField(this, 17, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest} returns this
 */
proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest.prototype.clearDoNotUploadInvoice = function() {
  return this.setDoNotUploadInvoice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.MakeGroupABillingEntityRequest.prototype.hasDoNotUploadInvoice = function() {
  return jspb.Message.getField(this, 17) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v2.MakeGroupABillingEntityResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v2.MakeGroupABillingEntityResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v2.MakeGroupABillingEntityResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.MakeGroupABillingEntityResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    group: (f = msg.getGroup()) && v2_types_billing_pb.HierarchyGroup.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v2.MakeGroupABillingEntityResponse}
 */
proto.loopup.ctgateway.v2.MakeGroupABillingEntityResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v2.MakeGroupABillingEntityResponse;
  return proto.loopup.ctgateway.v2.MakeGroupABillingEntityResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v2.MakeGroupABillingEntityResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v2.MakeGroupABillingEntityResponse}
 */
proto.loopup.ctgateway.v2.MakeGroupABillingEntityResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new v2_types_billing_pb.HierarchyGroup;
      reader.readMessage(value,v2_types_billing_pb.HierarchyGroup.deserializeBinaryFromReader);
      msg.setGroup(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v2.MakeGroupABillingEntityResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v2.MakeGroupABillingEntityResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v2.MakeGroupABillingEntityResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.MakeGroupABillingEntityResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGroup();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      v2_types_billing_pb.HierarchyGroup.serializeBinaryToWriter
    );
  }
};


/**
 * optional HierarchyGroup group = 1;
 * @return {?proto.loopup.ctgateway.v2.HierarchyGroup}
 */
proto.loopup.ctgateway.v2.MakeGroupABillingEntityResponse.prototype.getGroup = function() {
  return /** @type{?proto.loopup.ctgateway.v2.HierarchyGroup} */ (
    jspb.Message.getWrapperField(this, v2_types_billing_pb.HierarchyGroup, 1));
};


/**
 * @param {?proto.loopup.ctgateway.v2.HierarchyGroup|undefined} value
 * @return {!proto.loopup.ctgateway.v2.MakeGroupABillingEntityResponse} returns this
*/
proto.loopup.ctgateway.v2.MakeGroupABillingEntityResponse.prototype.setGroup = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.MakeGroupABillingEntityResponse} returns this
 */
proto.loopup.ctgateway.v2.MakeGroupABillingEntityResponse.prototype.clearGroup = function() {
  return this.setGroup(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.MakeGroupABillingEntityResponse.prototype.hasGroup = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v2.GetCommitmentsForGroupRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v2.GetCommitmentsForGroupRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v2.GetCommitmentsForGroupRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.GetCommitmentsForGroupRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    groupId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v2.GetCommitmentsForGroupRequest}
 */
proto.loopup.ctgateway.v2.GetCommitmentsForGroupRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v2.GetCommitmentsForGroupRequest;
  return proto.loopup.ctgateway.v2.GetCommitmentsForGroupRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v2.GetCommitmentsForGroupRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v2.GetCommitmentsForGroupRequest}
 */
proto.loopup.ctgateway.v2.GetCommitmentsForGroupRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setGroupId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v2.GetCommitmentsForGroupRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v2.GetCommitmentsForGroupRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v2.GetCommitmentsForGroupRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.GetCommitmentsForGroupRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGroupId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string group_id = 1;
 * @return {string}
 */
proto.loopup.ctgateway.v2.GetCommitmentsForGroupRequest.prototype.getGroupId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v2.GetCommitmentsForGroupRequest} returns this
 */
proto.loopup.ctgateway.v2.GetCommitmentsForGroupRequest.prototype.setGroupId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.loopup.ctgateway.v2.GetCommitmentsForGroupResponse.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v2.GetCommitmentsForGroupResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v2.GetCommitmentsForGroupResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v2.GetCommitmentsForGroupResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.GetCommitmentsForGroupResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    groupId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    commitmentsList: jspb.Message.toObjectList(msg.getCommitmentsList(),
    v2_types_billing_pb.Commitment.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v2.GetCommitmentsForGroupResponse}
 */
proto.loopup.ctgateway.v2.GetCommitmentsForGroupResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v2.GetCommitmentsForGroupResponse;
  return proto.loopup.ctgateway.v2.GetCommitmentsForGroupResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v2.GetCommitmentsForGroupResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v2.GetCommitmentsForGroupResponse}
 */
proto.loopup.ctgateway.v2.GetCommitmentsForGroupResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setGroupId(value);
      break;
    case 2:
      var value = new v2_types_billing_pb.Commitment;
      reader.readMessage(value,v2_types_billing_pb.Commitment.deserializeBinaryFromReader);
      msg.addCommitments(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v2.GetCommitmentsForGroupResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v2.GetCommitmentsForGroupResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v2.GetCommitmentsForGroupResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.GetCommitmentsForGroupResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGroupId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCommitmentsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      v2_types_billing_pb.Commitment.serializeBinaryToWriter
    );
  }
};


/**
 * optional string group_id = 1;
 * @return {string}
 */
proto.loopup.ctgateway.v2.GetCommitmentsForGroupResponse.prototype.getGroupId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v2.GetCommitmentsForGroupResponse} returns this
 */
proto.loopup.ctgateway.v2.GetCommitmentsForGroupResponse.prototype.setGroupId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated Commitment commitments = 2;
 * @return {!Array<!proto.loopup.ctgateway.v2.Commitment>}
 */
proto.loopup.ctgateway.v2.GetCommitmentsForGroupResponse.prototype.getCommitmentsList = function() {
  return /** @type{!Array<!proto.loopup.ctgateway.v2.Commitment>} */ (
    jspb.Message.getRepeatedWrapperField(this, v2_types_billing_pb.Commitment, 2));
};


/**
 * @param {!Array<!proto.loopup.ctgateway.v2.Commitment>} value
 * @return {!proto.loopup.ctgateway.v2.GetCommitmentsForGroupResponse} returns this
*/
proto.loopup.ctgateway.v2.GetCommitmentsForGroupResponse.prototype.setCommitmentsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.loopup.ctgateway.v2.Commitment=} opt_value
 * @param {number=} opt_index
 * @return {!proto.loopup.ctgateway.v2.Commitment}
 */
proto.loopup.ctgateway.v2.GetCommitmentsForGroupResponse.prototype.addCommitments = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.loopup.ctgateway.v2.Commitment, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.loopup.ctgateway.v2.GetCommitmentsForGroupResponse} returns this
 */
proto.loopup.ctgateway.v2.GetCommitmentsForGroupResponse.prototype.clearCommitmentsList = function() {
  return this.setCommitmentsList([]);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.loopup.ctgateway.v2.UpdateBillingEntityRequest.oneofGroups_ = [[10,11,12]];

/**
 * @enum {number}
 */
proto.loopup.ctgateway.v2.UpdateBillingEntityRequest.RegionCase = {
  REGION_NOT_SET: 0,
  US_STATE: 10,
  CANADIAN_PROVINCE: 11,
  OTHER_REGION: 12
};

/**
 * @return {proto.loopup.ctgateway.v2.UpdateBillingEntityRequest.RegionCase}
 */
proto.loopup.ctgateway.v2.UpdateBillingEntityRequest.prototype.getRegionCase = function() {
  return /** @type {proto.loopup.ctgateway.v2.UpdateBillingEntityRequest.RegionCase} */(jspb.Message.computeOneofCase(this, proto.loopup.ctgateway.v2.UpdateBillingEntityRequest.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v2.UpdateBillingEntityRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v2.UpdateBillingEntityRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v2.UpdateBillingEntityRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.UpdateBillingEntityRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    billingEntityId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    firstname: (f = msg.getFirstname()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    lastname: (f = msg.getLastname()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    emailAddress: (f = msg.getEmailAddress()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    phoneNumber: (f = msg.getPhoneNumber()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    address1: (f = msg.getAddress1()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    address2: (f = msg.getAddress2()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    address3: (f = msg.getAddress3()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    city: (f = msg.getCity()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    usState: jspb.Message.getFieldWithDefault(msg, 10, 0),
    canadianProvince: jspb.Message.getFieldWithDefault(msg, 11, 0),
    otherRegion: (f = msg.getOtherRegion()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    zip: (f = msg.getZip()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    countryCode: (f = msg.getCountryCode()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    company: (f = msg.getCompany()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    doNotUploadInvoice: (f = msg.getDoNotUploadInvoice()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v2.UpdateBillingEntityRequest}
 */
proto.loopup.ctgateway.v2.UpdateBillingEntityRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v2.UpdateBillingEntityRequest;
  return proto.loopup.ctgateway.v2.UpdateBillingEntityRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v2.UpdateBillingEntityRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v2.UpdateBillingEntityRequest}
 */
proto.loopup.ctgateway.v2.UpdateBillingEntityRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setBillingEntityId(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setFirstname(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setLastname(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setEmailAddress(value);
      break;
    case 5:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setPhoneNumber(value);
      break;
    case 6:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setAddress1(value);
      break;
    case 7:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setAddress2(value);
      break;
    case 8:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setAddress3(value);
      break;
    case 9:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setCity(value);
      break;
    case 10:
      var value = /** @type {!proto.loopup.ctgateway.v2.UsState} */ (reader.readEnum());
      msg.setUsState(value);
      break;
    case 11:
      var value = /** @type {!proto.loopup.ctgateway.v2.CanadianProvince} */ (reader.readEnum());
      msg.setCanadianProvince(value);
      break;
    case 12:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setOtherRegion(value);
      break;
    case 13:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setZip(value);
      break;
    case 14:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setCountryCode(value);
      break;
    case 15:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setCompany(value);
      break;
    case 16:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setDoNotUploadInvoice(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v2.UpdateBillingEntityRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v2.UpdateBillingEntityRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v2.UpdateBillingEntityRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.UpdateBillingEntityRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBillingEntityId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFirstname();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getLastname();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getEmailAddress();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getPhoneNumber();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getAddress1();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getAddress2();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getAddress3();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getCity();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = /** @type {!proto.loopup.ctgateway.v2.UsState} */ (jspb.Message.getField(message, 10));
  if (f != null) {
    writer.writeEnum(
      10,
      f
    );
  }
  f = /** @type {!proto.loopup.ctgateway.v2.CanadianProvince} */ (jspb.Message.getField(message, 11));
  if (f != null) {
    writer.writeEnum(
      11,
      f
    );
  }
  f = message.getOtherRegion();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getZip();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getCountryCode();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getCompany();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getDoNotUploadInvoice();
  if (f != null) {
    writer.writeMessage(
      16,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional string billing_entity_id = 1;
 * @return {string}
 */
proto.loopup.ctgateway.v2.UpdateBillingEntityRequest.prototype.getBillingEntityId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v2.UpdateBillingEntityRequest} returns this
 */
proto.loopup.ctgateway.v2.UpdateBillingEntityRequest.prototype.setBillingEntityId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.StringValue firstname = 2;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.UpdateBillingEntityRequest.prototype.getFirstname = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 2));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.UpdateBillingEntityRequest} returns this
*/
proto.loopup.ctgateway.v2.UpdateBillingEntityRequest.prototype.setFirstname = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.UpdateBillingEntityRequest} returns this
 */
proto.loopup.ctgateway.v2.UpdateBillingEntityRequest.prototype.clearFirstname = function() {
  return this.setFirstname(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.UpdateBillingEntityRequest.prototype.hasFirstname = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.StringValue lastname = 3;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.UpdateBillingEntityRequest.prototype.getLastname = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 3));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.UpdateBillingEntityRequest} returns this
*/
proto.loopup.ctgateway.v2.UpdateBillingEntityRequest.prototype.setLastname = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.UpdateBillingEntityRequest} returns this
 */
proto.loopup.ctgateway.v2.UpdateBillingEntityRequest.prototype.clearLastname = function() {
  return this.setLastname(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.UpdateBillingEntityRequest.prototype.hasLastname = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.StringValue email_address = 4;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.UpdateBillingEntityRequest.prototype.getEmailAddress = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 4));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.UpdateBillingEntityRequest} returns this
*/
proto.loopup.ctgateway.v2.UpdateBillingEntityRequest.prototype.setEmailAddress = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.UpdateBillingEntityRequest} returns this
 */
proto.loopup.ctgateway.v2.UpdateBillingEntityRequest.prototype.clearEmailAddress = function() {
  return this.setEmailAddress(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.UpdateBillingEntityRequest.prototype.hasEmailAddress = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.StringValue phone_number = 5;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.UpdateBillingEntityRequest.prototype.getPhoneNumber = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 5));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.UpdateBillingEntityRequest} returns this
*/
proto.loopup.ctgateway.v2.UpdateBillingEntityRequest.prototype.setPhoneNumber = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.UpdateBillingEntityRequest} returns this
 */
proto.loopup.ctgateway.v2.UpdateBillingEntityRequest.prototype.clearPhoneNumber = function() {
  return this.setPhoneNumber(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.UpdateBillingEntityRequest.prototype.hasPhoneNumber = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional google.protobuf.StringValue address1 = 6;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.UpdateBillingEntityRequest.prototype.getAddress1 = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 6));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.UpdateBillingEntityRequest} returns this
*/
proto.loopup.ctgateway.v2.UpdateBillingEntityRequest.prototype.setAddress1 = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.UpdateBillingEntityRequest} returns this
 */
proto.loopup.ctgateway.v2.UpdateBillingEntityRequest.prototype.clearAddress1 = function() {
  return this.setAddress1(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.UpdateBillingEntityRequest.prototype.hasAddress1 = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional google.protobuf.StringValue address2 = 7;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.UpdateBillingEntityRequest.prototype.getAddress2 = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 7));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.UpdateBillingEntityRequest} returns this
*/
proto.loopup.ctgateway.v2.UpdateBillingEntityRequest.prototype.setAddress2 = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.UpdateBillingEntityRequest} returns this
 */
proto.loopup.ctgateway.v2.UpdateBillingEntityRequest.prototype.clearAddress2 = function() {
  return this.setAddress2(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.UpdateBillingEntityRequest.prototype.hasAddress2 = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional google.protobuf.StringValue address3 = 8;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.UpdateBillingEntityRequest.prototype.getAddress3 = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 8));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.UpdateBillingEntityRequest} returns this
*/
proto.loopup.ctgateway.v2.UpdateBillingEntityRequest.prototype.setAddress3 = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.UpdateBillingEntityRequest} returns this
 */
proto.loopup.ctgateway.v2.UpdateBillingEntityRequest.prototype.clearAddress3 = function() {
  return this.setAddress3(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.UpdateBillingEntityRequest.prototype.hasAddress3 = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional google.protobuf.StringValue city = 9;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.UpdateBillingEntityRequest.prototype.getCity = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 9));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.UpdateBillingEntityRequest} returns this
*/
proto.loopup.ctgateway.v2.UpdateBillingEntityRequest.prototype.setCity = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.UpdateBillingEntityRequest} returns this
 */
proto.loopup.ctgateway.v2.UpdateBillingEntityRequest.prototype.clearCity = function() {
  return this.setCity(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.UpdateBillingEntityRequest.prototype.hasCity = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional UsState us_state = 10;
 * @return {!proto.loopup.ctgateway.v2.UsState}
 */
proto.loopup.ctgateway.v2.UpdateBillingEntityRequest.prototype.getUsState = function() {
  return /** @type {!proto.loopup.ctgateway.v2.UsState} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {!proto.loopup.ctgateway.v2.UsState} value
 * @return {!proto.loopup.ctgateway.v2.UpdateBillingEntityRequest} returns this
 */
proto.loopup.ctgateway.v2.UpdateBillingEntityRequest.prototype.setUsState = function(value) {
  return jspb.Message.setOneofField(this, 10, proto.loopup.ctgateway.v2.UpdateBillingEntityRequest.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.UpdateBillingEntityRequest} returns this
 */
proto.loopup.ctgateway.v2.UpdateBillingEntityRequest.prototype.clearUsState = function() {
  return jspb.Message.setOneofField(this, 10, proto.loopup.ctgateway.v2.UpdateBillingEntityRequest.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.UpdateBillingEntityRequest.prototype.hasUsState = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional CanadianProvince canadian_province = 11;
 * @return {!proto.loopup.ctgateway.v2.CanadianProvince}
 */
proto.loopup.ctgateway.v2.UpdateBillingEntityRequest.prototype.getCanadianProvince = function() {
  return /** @type {!proto.loopup.ctgateway.v2.CanadianProvince} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {!proto.loopup.ctgateway.v2.CanadianProvince} value
 * @return {!proto.loopup.ctgateway.v2.UpdateBillingEntityRequest} returns this
 */
proto.loopup.ctgateway.v2.UpdateBillingEntityRequest.prototype.setCanadianProvince = function(value) {
  return jspb.Message.setOneofField(this, 11, proto.loopup.ctgateway.v2.UpdateBillingEntityRequest.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.UpdateBillingEntityRequest} returns this
 */
proto.loopup.ctgateway.v2.UpdateBillingEntityRequest.prototype.clearCanadianProvince = function() {
  return jspb.Message.setOneofField(this, 11, proto.loopup.ctgateway.v2.UpdateBillingEntityRequest.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.UpdateBillingEntityRequest.prototype.hasCanadianProvince = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional google.protobuf.StringValue other_region = 12;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.UpdateBillingEntityRequest.prototype.getOtherRegion = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 12));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.UpdateBillingEntityRequest} returns this
*/
proto.loopup.ctgateway.v2.UpdateBillingEntityRequest.prototype.setOtherRegion = function(value) {
  return jspb.Message.setOneofWrapperField(this, 12, proto.loopup.ctgateway.v2.UpdateBillingEntityRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.UpdateBillingEntityRequest} returns this
 */
proto.loopup.ctgateway.v2.UpdateBillingEntityRequest.prototype.clearOtherRegion = function() {
  return this.setOtherRegion(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.UpdateBillingEntityRequest.prototype.hasOtherRegion = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional google.protobuf.StringValue zip = 13;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.UpdateBillingEntityRequest.prototype.getZip = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 13));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.UpdateBillingEntityRequest} returns this
*/
proto.loopup.ctgateway.v2.UpdateBillingEntityRequest.prototype.setZip = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.UpdateBillingEntityRequest} returns this
 */
proto.loopup.ctgateway.v2.UpdateBillingEntityRequest.prototype.clearZip = function() {
  return this.setZip(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.UpdateBillingEntityRequest.prototype.hasZip = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional google.protobuf.StringValue country_code = 14;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.UpdateBillingEntityRequest.prototype.getCountryCode = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 14));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.UpdateBillingEntityRequest} returns this
*/
proto.loopup.ctgateway.v2.UpdateBillingEntityRequest.prototype.setCountryCode = function(value) {
  return jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.UpdateBillingEntityRequest} returns this
 */
proto.loopup.ctgateway.v2.UpdateBillingEntityRequest.prototype.clearCountryCode = function() {
  return this.setCountryCode(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.UpdateBillingEntityRequest.prototype.hasCountryCode = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional google.protobuf.StringValue company = 15;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.UpdateBillingEntityRequest.prototype.getCompany = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 15));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.UpdateBillingEntityRequest} returns this
*/
proto.loopup.ctgateway.v2.UpdateBillingEntityRequest.prototype.setCompany = function(value) {
  return jspb.Message.setWrapperField(this, 15, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.UpdateBillingEntityRequest} returns this
 */
proto.loopup.ctgateway.v2.UpdateBillingEntityRequest.prototype.clearCompany = function() {
  return this.setCompany(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.UpdateBillingEntityRequest.prototype.hasCompany = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional google.protobuf.BoolValue do_not_upload_invoice = 16;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.loopup.ctgateway.v2.UpdateBillingEntityRequest.prototype.getDoNotUploadInvoice = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 16));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.UpdateBillingEntityRequest} returns this
*/
proto.loopup.ctgateway.v2.UpdateBillingEntityRequest.prototype.setDoNotUploadInvoice = function(value) {
  return jspb.Message.setWrapperField(this, 16, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.UpdateBillingEntityRequest} returns this
 */
proto.loopup.ctgateway.v2.UpdateBillingEntityRequest.prototype.clearDoNotUploadInvoice = function() {
  return this.setDoNotUploadInvoice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.UpdateBillingEntityRequest.prototype.hasDoNotUploadInvoice = function() {
  return jspb.Message.getField(this, 16) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v2.UpdateBillingEntityResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v2.UpdateBillingEntityResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v2.UpdateBillingEntityResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.UpdateBillingEntityResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    group: (f = msg.getGroup()) && v2_types_billing_pb.HierarchyGroup.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v2.UpdateBillingEntityResponse}
 */
proto.loopup.ctgateway.v2.UpdateBillingEntityResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v2.UpdateBillingEntityResponse;
  return proto.loopup.ctgateway.v2.UpdateBillingEntityResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v2.UpdateBillingEntityResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v2.UpdateBillingEntityResponse}
 */
proto.loopup.ctgateway.v2.UpdateBillingEntityResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new v2_types_billing_pb.HierarchyGroup;
      reader.readMessage(value,v2_types_billing_pb.HierarchyGroup.deserializeBinaryFromReader);
      msg.setGroup(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v2.UpdateBillingEntityResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v2.UpdateBillingEntityResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v2.UpdateBillingEntityResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.UpdateBillingEntityResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGroup();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      v2_types_billing_pb.HierarchyGroup.serializeBinaryToWriter
    );
  }
};


/**
 * optional HierarchyGroup group = 1;
 * @return {?proto.loopup.ctgateway.v2.HierarchyGroup}
 */
proto.loopup.ctgateway.v2.UpdateBillingEntityResponse.prototype.getGroup = function() {
  return /** @type{?proto.loopup.ctgateway.v2.HierarchyGroup} */ (
    jspb.Message.getWrapperField(this, v2_types_billing_pb.HierarchyGroup, 1));
};


/**
 * @param {?proto.loopup.ctgateway.v2.HierarchyGroup|undefined} value
 * @return {!proto.loopup.ctgateway.v2.UpdateBillingEntityResponse} returns this
*/
proto.loopup.ctgateway.v2.UpdateBillingEntityResponse.prototype.setGroup = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.UpdateBillingEntityResponse} returns this
 */
proto.loopup.ctgateway.v2.UpdateBillingEntityResponse.prototype.clearGroup = function() {
  return this.setGroup(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.UpdateBillingEntityResponse.prototype.hasGroup = function() {
  return jspb.Message.getField(this, 1) != null;
};


goog.object.extend(exports, proto.loopup.ctgateway.v2);
